"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSnapshotSection = void 0;
var ReportSnapshotSection;
(function (ReportSnapshotSection) {
    ReportSnapshotSection["ORDERS"] = "reports_snapshot_orders";
    ReportSnapshotSection["PAYMENTS"] = "reports_snapshot_payments";
    ReportSnapshotSection["PRODUCTS"] = "reports_snapshot_products";
    ReportSnapshotSection["INVENTORY"] = "reports_snapshot_inventory";
    ReportSnapshotSection["SUPPLIERS"] = "reports_snapshot_suppliers";
    ReportSnapshotSection["CUSTOMERS"] = "reports_snapshot_customers";
    ReportSnapshotSection["CUSTOMERS_ACTIVITY"] = "reports_snapshot_customers_activity";
    ReportSnapshotSection["CUSTOMERS_REVENUE"] = "reports_snapshot_customers_revenue";
})(ReportSnapshotSection = exports.ReportSnapshotSection || (exports.ReportSnapshotSection = {}));
